var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hold-transition login-page"},[_c('div',{staticClass:"login-box"},[_c('img',{attrs:{"src":require("@/assets/logo.png"),"id":"logo"}}),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body login-card-body"},[_c('router-view')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }